import React from 'react'
import { connect } from 'react-redux'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import ItemsToBePurchasedSelect from './ItemsToBePurchasedSelect'
import { exportFile } from 'tyan/public/index'
import RequisitionDiv from '../RequisitionManageMent/RequisitionDiv'
class PurchaseDiv extends React.Component {
	state = {
		noEdit: this.props.noEdit || true,
		tabName: this.props.tabName || '',
	}

	componentDidMount = () => {
		const { id } = this.props
		this.handlerInitValue(id)
	}

	handlerInitValue = (id) => {
		Tyan.doPostEvent({
			event: 'GetPurchase',
			data: { id },
			onEnd: ({ errorMessage, initValues基本信息, initValues采购明细, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, initValues采购明细, changedValues采购明细: {}, optionsParas })
				}
			}
		})
	}

	handlerSave = (name = '') => {
		const { id, changedValues基本信息, changedValues采购明细 } = this.state
		const 币别 = getFormValue(this, '基本信息', '币别')
		const 供应商 = getFormValue(this, '基本信息', '供应商')
		if (!供应商) {
			Ext.toast('供应商必填')
			return
		}
		if (!币别) {
			Ext.toast('币别必填')
			return
		}
		if (this.bChanged())
			Tyan.doPostEvent({
				event: 'SavePurchase',
				data: { id, changedValues基本信息, changedValues采购明细 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('保存成功')
						this.handlerInitValue(id)
						if (name !== '') {
							Tyan.pubForm.showDialog('选择待采购物品', props => <ItemsToBePurchasedSelect {...props} id={id}
								onSave={() => this.handlerInitValue(id)} />)
						}
					}
				}
			})
		else {
			if (name !== '') {
				Tyan.pubForm.showDialog('选择待采购物品', props => <ItemsToBePurchasedSelect {...props} id={id}
					onSave={() => this.handlerInitValue(id)} />)
			}
		}
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeletePurchase',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handleCurrencyNameChange = (v) => {
		const 申请时间 = getFormValue(this, '基本信息', '申请时间')
		Tyan.doPostEvent({
			event: 'GetExchangeRateByCurrency',
			data: { 币别: v, 申请时间 },
			onEnd: ({ errorMessage, ExchangeRate }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
					this.AutoCalculation()
				}
			}
		})
	}

	handleSupplierChange = (v) => {
		const { optionsParas } = this.state
		Tyan.doPostEvent({
			event: 'GetSupplierByName',
			data: { 供应商: v },
			onEnd: ({ errorMessage, 付款方式, 付款条件, options, 联系人, 邮件, 电话 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					if (options)
						this.setState({ optionsParas: { ...optionsParas, ...options } })
					changeItemsValue(this, '基本信息', ['付款方式', '付款条件', '联系人', '邮件', '电话'], [付款方式, 付款条件, 联系人, 邮件, 电话])
				}
			}
		})
	}
	handleContactChange = (v) => {
		const 供应商 = getFormValue(this, '基本信息', '供应商')
		Tyan.doPostEvent({
			event: 'GetSupplierContactInfo',
			data: { contactName: v, supplierName: 供应商 },
			onEnd: ({ errorMessage, ContactInfo }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['联系人', '电话', '邮件'], [ContactInfo.ContactName, ContactInfo.Phone, ContactInfo.Email])
				}
			}
		})
	}
	handlerDeleteInfo = (id) => {
		this.handlerSave('')
		const { id: reqPurchaseID } = this.state
		Tyan.doPostEvent({
			event: 'DeletePurchaseInfo',
			data: { id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(reqPurchaseID)
				}
			}
		})
	}

	AutoCalculation = (id = 0) => {
		// const 汇率 = getFormValue(this, '基本信息', '汇率')
		const { list } = getListItems(this, '采购明细', '采购明细')
		// var d未税金额 = 0
		// var d含税金额 = 0
		// var d本币未税金额Total = 0
		// var d本币含税金额Total = 0
		var d含税金额Total = 0
		if (list.length > 0) {
			list.forEach(o => {
				var d未税单价 = 0
				var d税额 = 0
				var d未税金额 = 0
				var d含税金额 = 0
				var d税率 = 0
				if (o.税率) {
					if (o.税率 == 'CN01：增值税13%')
						d税率 = 0.13
					else if (o.税率 == 'CN02：增值税9%')
						d税率 = 0.09
					else if (o.税率 == 'CN03：增值税6%')
						d税率 = 0.06
					else if (o.税率 == 'CN04：增值税3%')
						d税率 = 0.03
					else if (o.税率 == 'CN05：增值税1%')
						d税率 = 0.01
				}
				// if (汇率) {
				//     d本币单价 = o.原币单价 * 汇率
				//     d本币含税单价 = o.原币单价 * 汇率 * (1 + d税率)
				//     d本币未税金额 = o.原币单价 * 汇率 * o.数量
				//     d本币含税金额 = o.原币单价 * 汇率 * o.数量 * (1 + d税率)
				// }

				// d未税金额 += o.原币单价 * o.数量
				// d含税金额 += o.原币单价 * o.数量 * (1 + d税率)
				// d本币未税金额Total += d本币未税金额
				// d本币含税金额Total += d本币含税金额

				d未税单价 = o.含税单价 / (1 + d税率)
				d税额 = d未税单价 * o.数量 * d税率
				d未税金额 = d未税单价 * o.数量
				d含税金额 = o.含税单价 * o.数量

				d含税金额Total += parseFloat(d含税金额.toFixed(2))

				if (id > 0 && o.id == id)
					changeListItem(this,
						{
							'未税单价': d未税单价,
							'税额': d税额.toFixed(2),
							'未税金额': d未税金额.toFixed(2),
							'含税金额': d含税金额.toFixed(2)
						},
						{
							'未税单价': 'string',
							'税额': 'string',
							'未税金额': 'string',
							'含税金额': 'string'
						},
						'采购明细', '采购明细', o.id)
			})
			//console.log('d含税金额Total',d含税金额Total)
			changeItemsValue(this, '基本信息', ['含税金额'], [d含税金额Total])
		}
	}
	handlerGetRequisition = (id) => {
		const 请购单号 = getFormValue(this, '采购明细', `采购明细[${id}].请购单号`)
		Tyan.doPostEvent({
			event: 'GetRequisitionID',
			data: { 请购单号 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				Tyan.pubForm.showDialog('请购信息', props => <RequisitionDiv {...props} id={id} readOnly={true} />)
			}
		})
		// Tyan.pubForm.showDialog('', props => <RequisitionDiv {...props} id={id} onlyView={true} readOnly={true}/>)
	}

	handlerPurchaseExport = () => {
		const { id } = this.state
		exportFile(null, null, "PurchaseExport?id=" + id)
	}

	handlerPurchaseOrderPrint = () => {
		const { id } = this.state
		exportFile(null, null, "PurchaseOrderPrint?id=" + id)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		return true
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	fieldset基本信息 = () => {
		const 状态 = getFormValue(this, '基本信息', '状态')
		const { readOnly } = this.props
		const s = { margin: '5px 15px 5px 15px', minWidth: 150, flex: 1 }
		const { list } = getListItems(this, '采购明细', '采购明细')
		var _fieldset = [
			{ _text: '采购单号', minWidth: '45%', disabled: true },
			{ _date: '申请时间', minWidth: '45%', disabled: true },
			{ _text: '申请人', minWidth: '45%', disabled: true },
			{ _text: '申请部门', minWidth: '45%', disabled: true },
			{ _radio: '加急件', minWidth: '90%' },
			{ _text: '采购项目', minWidth: '90%', disabled: true, maxRows: 3 },
			//{ _select: '使用部门', minWidth: '45%' },
			{ _select: '供应商', minWidth: '45%', required: true, editable: true, onChange: (v) => this.handleSupplierChange(v) },
			{ _text: '交货方式', minWidth: '45%', },
			{ _select: '联系人', minWidth: '45%', onChange: (v) => this.handleContactChange(v) },
			{ _text: '邮件', minWidth: '45%', disabled: true },
			{ _text: '电话', minWidth: '45%', disabled: true },
			{ _select: '付款方式', minWidth: '45%' },
			{ _select: '付款条件', minWidth: '45%' },
			{ _select: '币别', minWidth: '45%', required: true, onChange: (v) => this.handleCurrencyNameChange(v), disabled: list.length > 0 },
			{ _float: '汇率', minWidth: '45%', disabled: true, textAlign: 'left', decimals: 4 },
			{ _float: '含税总金额', name: '含税金额', minWidth: '45%', disabled: true, textAlign: 'left' },
			// { _float: '含税金额', minWidth: '45%', disabled: true, textAlign: 'left' },
			// { _float: '本币未税金额', minWidth: '45%', disabled: true, textAlign: 'left' },
			// { _float: '本币含税金额', minWidth: '90%', disabled: true, textAlign: 'left' },
			{ _text: '价格条件', minWidth: '45%', },
			{ _text: '备注', minWidth: '90%', maxRows: 3 },
			{ _files: '请购附件', minWidth: '90%', disabled: true },
			{ _files: '附件', minWidth: '90%' },
		]

		list.forEach((o, iNo) => {
			const _list = { listName: '采购明细', id: o.id }
			_fieldset.push({
				_border: `采购明细${iNo + 1}`, name: `采购明细[${o.id}]`, list: _list, margin: '15 0 5 0', minWidth: '90%', fieldset: '采购明细', items: [
					//{ _radio: '请购状态', itemMinWidth: 125, minWidth: '45%', disabled: readOnly || 状态 == '申请中' || 状态 == '已完成', cdt: () => 状态 != '申请中' },
					//{ _text: '不予采购人', minWidth: '45%', cdt: () => 状态 != '申请中' && o.请购状态 == '不予采购', },
					{ _text: '物料名称', minWidth: '45%', disabled: true },
					{
						_group: '', minWidth: '45%', margin: 0, items: [
							{ _text: '请购单号', minWidth: '20%', disabled: true },
							{
								_buttons: [
									{
										_button: '查看', icon: 'info-circle', ui: '', margin: 0,
										handler: () => this.handlerGetRequisition(o.id),
									},
								], width: 100, margin: 0,
							},
						]
					},
					{ _text: '单位', minWidth: '45%', disabled: true },
					{ _text: '规格型号', minWidth: '45%', },
					{ _float: '数量', minWidth: '45%', onChange: () => this.AutoCalculation(o.id) },
					{ _text: '制造商', minWidth: '45%', disabled: true },
					{ _float: '未税单价', minWidth: '45%', disabled: true, decimals: 4 },
					{ _float: '含税单价', minWidth: '45%', onChange: () => this.AutoCalculation(o.id), decimals: 4 },
					{ _float: '未税金额', minWidth: '45%' },
					{ _float: '含税金额', minWidth: '45%', disabled: true },
					{ _select: '税率', minWidth: '45%', onChange: () => this.AutoCalculation(o.id) },
					{ _float: '税额', minWidth: '45%' },
					{ _select: '使用部门', minWidth: '45%' },
					{ _text: '物料代码', minWidth: '45%', disabled: true },
					{ _text: '用途', minWidth: '45%', },
					{ _select: '类别', minWidth: '45%', },
					{ _select: '受益设备', minWidth: '95%', editable: true, },
					//{ _date: '建议采购日期', minWidth: '45%', },
					{ _date: '预计到货日期', name: '到货日期', minWidth: '45%', },
					// { _float: '原币单价', minWidth: '45%', onChange: () => this.AutoCalculation(o.id) },
					// { _float: '本币单价', minWidth: '45%', disabled: true },
					{
						_buttons: [
							{
								_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0, hidden: readOnly || 状态 !== '申请中',
								handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id) }),
							},
						], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
					},
				]
			})
		})
		return _fieldset
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly, noEdit } = this.props
		const { initValues基本信息, id, tabName } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态, 提交时间 } = initValues基本信息
		return <Body data={this} maxWidth="100%"
			controls={
				readOnly ? [
					{ _flow: 'PurchaseFlow', disabled: this.bChanged(), cdt: () => tabName == '已完成', },
					{ _button: '打印', icon: 'print', handler: this.handlerPurchaseExport, cdt: () => id > 0 && 状态 == '已完成', },
					{ _button: '打印凭证', icon: 'print', handler: this.handlerPurchaseOrderPrint, cdt: () => id > 0 && 状态 == '已完成' },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				] :
					[
						{ _flow: 'PurchaseFlow', disabled: this.bChanged(), cdt: () => id > 0, },
						{ _button: '打印', icon: 'print', handler: this.handlerPurchaseExport, cdt: () => id > 0 && 状态 == '已完成' && noEdit },
						{ _button: '打印凭证', icon: 'print', handler: this.handlerPurchaseOrderPrint, cdt: () => id > 0 && 状态 == '已完成' && noEdit, },
						{ _button: '选择待采购物品...', icon: 'plus', handler: () => this.handlerSave('选择待采购物品'), cdt: () => 状态 == '申请中' },
						{ _button: '保存', icon: 'save', handler: () => this.handlerSave(''), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 != '已完成' },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: (readOnly || 状态 !== '申请中') && !noEdit },
					{
						_fieldsets: [
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						], docked: 'right', width: '40%',
					}
				]}
		/>
	}
}

export default connect()(PurchaseDiv)